import { render, staticRenderFns } from "./aiCompanyheader.vue?vue&type=template&id=029906aa&scoped=true&"
import script from "./aiCompanyheader.vue?vue&type=script&lang=js&"
export * from "./aiCompanyheader.vue?vue&type=script&lang=js&"
import style0 from "./aiCompanyheader.vue?vue&type=style&index=0&id=029906aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029906aa",
  null
  
)

export default component.exports